import React from "react";
import { Card, Input, Typography, Dropdown } from "antd";
import "./style.css";
import Video from "../../../assets/video.JPG";
import Like from "../../../assets/like.png";
import Profile from "../../../assets/profile-image.png";
import TitleImg from "../../../assets/title.png";
import {
  LikeOutlined,
  ShareAltOutlined,
  SmileOutlined,
  FileImageOutlined,
  CaretDownOutlined,
} from "@ant-design/icons";
import { NewsSort } from "../Dropdowns";
import { Player } from "video-react";
import { BiMessageDots } from "react-icons/bi";
import { HiDotsHorizontal } from "react-icons/hi";


const { Title } = Typography;

const suffix = (
  <>
    <SmileOutlined
      style={{ fontSize: "20px", color: "#77767A", marginRight: "10px" }}
    />
    <FileImageOutlined style={{ fontSize: "20px", color: "#77767A" }} />
  </>
);

const NewsBox = () => {
  return (
    <>
      <Dropdown overlay={NewsSort} placement="bottomRight" arrow>
        <div className="text-right mb-2 hidden lg:block">
          <p className="inline">Sort By</p>
          <CaretDownOutlined />
        </div>
      </Dropdown>
      <Card className="card newsCard no-border" style={{borderRadius: 10}}>
        <div className="px-5 py-5 flex justify-between">
          <div className="flex">
            <div className="w-11 h-11 rounded-full flex overflow-hidden">
              <img src={TitleImg} width={70} />
            </div>
            <div className="ml-2">
              <Title level={5}>Sport News</Title>
              <p> Story by Andy Richard</p>
              <p className="timeStamp">03:57 pm, Today</p>
            </div>
          </div>
          <HiDotsHorizontal />
        </div>
        <div className="px-5 py-5 newsContent">
          <p className="text-md 2xl:text-base">
            FC Koln manager Steffen Baugmart had to watch his team from home
            this weekend because of COVID-19. This video sums it all
          </p>
          <Title level={5}>#FCKoln #SteffenBaugmart</Title>
        </div>
        <div>
          <Player
            playsInline
            poster={Video}
            src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
          />
        </div>
        <div className="px-5 py-5 flex justify-between">
          <div className="flex items-center">
            <img src={Like} width={40} />
            <p>20</p>
          </div>
          <div className="flex items-center">
            <p>74 Comments</p>
          </div>
        </div>
        <div className="mx-5 my-2 flex justify-between social py-5">
          <div className="flex items-center">
            <LikeOutlined
              style={{
                fontSize: "20px",
                color: "#77767A",
                marginRight: "10px",
              }}
            />
            <label className="text-md font-bold">Like</label>
          </div>
          <div className="flex items-center">
            <BiMessageDots
              style={{
                fontSize: "20px",
                color: "#77767A",
                marginRight: "10px",
              }}
            />
            <label className="text-base font-bold">Comment</label>
          </div>
          <div className="flex items-center">
            <ShareAltOutlined
              style={{
                fontSize: "20px",
                color: "#77767A",
                marginRight: "10px",
              }}
            />
            <label className="text-base font-bold">Share</label>
          </div>
        </div>
        <div className="px-5 py-5 flex items-center">
          <div className="w-11 h-11 rounded-full flex overflow-hidden">
            <img src={Profile} />
          </div>
          <div className="w-full ml-2">
            <Input
              size="large"
              placeholder="Write a comment..."
              suffix={suffix}
              className="w-full rounded-3xl"
              style={{borderRadius: 20}}
            />
          </div>
        </div>
        <div className="px-5 py-5 flex item-center">
          <div className="w-11 h-11 rounded-full flex overflow-hidden">
            <img src={Profile} />
          </div>
          <div className="w-full ml-2">
            <div className="comment-box">
              <Title level={5}>Victor Stephson</Title>
              <p className="py-2 lg:py-5">
                This transfer season is going to be crazy. I am very sure
                Manchester will delay
              </p>
            </div>
            <div className="mt-2 comment-actions">
              <p className="inline">Like</p>
              <p className="inline">Reply</p>
            </div>
          </div>
        </div>
        <div className="px-5 py-5 flex item-center">
          <div className="w-11 h-11 rounded-full flex overflow-hidden">
            <img src={Profile} />
          </div>
          <div className="w-full ml-2">
            <div className="comment-box">
              <Title level={5}>Victor Stephson</Title>
              <p className="py-2">
                This transfer season is going to be crazy. I am very sure
                Manchester will delay
              </p>
            </div>
            <div className="mt-2 comment-actions">
              <p className="inline">Like</p>
              <p className="inline">Reply</p>
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default NewsBox;
